<template>
    <zm-button
      size='large'
      round
      type="primary"
      @click="handleClick"
    >
      {{ ctaName }}
    </zm-button>
</template>

<script>
import setupMixin from "@/views/success/mixin/set-up";
import { mapGetters } from 'vuex';
import { plansof } from '@/utils/chain';
import { planTypes } from '@/common/constants';

export default {
  mixins: [setupMixin],
  props: {
    showExplore: Boolean,
  },
  computed: {
    ...mapGetters(['boughtPlans']),
    isSetUpZPCTA() {
      return plansof(this.boughtPlans).type(planTypes.ZOOM_ONE_BUNDLE, planTypes.ZONE_PRO_PLUS,planTypes.ZOOM_PHONE,planTypes.ZOOM_PHONE$ZPA,planTypes.ZOOM_PHONE$ZPI).has();
    },
    ctaName() {
      if (this.companySetupZoomOneName) {
        return this.companySetupZoomOneName;
      } else if (this.isSetUpZPCTA) {
        return this.$t('Set up Zoom Phone');
      } else {
        return this.$t('billing.success.confirmation.view_my_plan');
      }
    },
  },
  methods: {
    goBilling() {
      window.location.href = '/billing';
    },
    handleClick() {
      this.$tracking.buyInteraction('purchase confirmation', this.ctaName?.toLowerCase?.());
      if (this.companySetupZoomOneName) {
        this.goCompanySetup();
      } else if (this.isSetUpZPCTA) {
        window.location.href = '/pbx/page/telephone/new?p=new';
      } else {
        window.location.href = '/billing';
      }
    }
  }
}
</script>

<style lang="scss">

</style>
